import React, { useState } from 'react'

const Faq = () => {
    return (
        <div>
            <section className="relative z-20 m-10  overflow-hidden bg-white pb-1 pt-1 dark:bg-dark lg:pb-[90px] ">
                <div className="container  mx-auto">
                    <div className="-mx-4 flex flex-wrap">
                        <div className="w-full px-4">
                            <div className="mx-auto  text-center lg:mb-20">
                                <h2 className="text-3xl font-semibold font-mfont text-mcolor sm:text-4xl">
                                    Frequently asked questions?
                                </h2>
                            </div>
                        </div>
                    </div>

                    <div className="-mx-4 flex lg:mt-0 mt-10 gap-5 lg:gap-0 flex-wrap">
                        <div className="w-full px-4  lg:w-1/2">
                            <AccordionItem
                                header="What are the training programs available for Making Minds Technologies products?"
                                text="Our training programs include one-on-one online instruction and
                                 virtual classes. Following schedule finalization, customers can 
                                 register for a virtual classroom session that best suits their
                                  schedules on our forthcoming training website. A variety of organizations'
                                   users will be present for this training. One-on-one instruction,
                                    on the other hand, is scheduled at the convenience of the customer 
                                    upon request. One or more users from a single organization will be
                                     the only ones receiving this training."
                            />


                        </div>
                        <div className="w-full px-4  lg:w-1/2">
                            <AccordionItem
                                header="What is the difference between online training and virtual classrooms?"
                                text="Our online training program is planned based on user requests and
                                 is contingent upon the availability of both the trainer and the user. 
                                 Trainers work one-on-one with each organization, and they only work with
                                  one at a time. On this page, users may choose a comfortable time window
                                   for themselves based on their time zone. Virtual classes, on the other
                                    hand, are arranged in advance. The online session will be facilitated 
                                    by an instructor, allowing all learners to view and communicate with 
                                    one another. Participants in virtual classroom sessions will come from
                                     various organizations. "
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Faq

const AccordionItem = ({ header, text }) => {
    const [active, setActive] = useState(false);

    const handleToggle = () => {
        // event.preventDefault();
        setActive(!active);
    };
    return (
        <div className=" w-full  rounded-lg bg-white p-4 border order-mblack sm:p-8 lg:px-6 xl:px-8">
            <button className={`faq-btn flex w-full text-left`} onClick={() => handleToggle()} >
                <div className="mr-5  flex h-10 w-full max-w-[40px] items-center justify-center rounded-lg bg-blue-100 text-blue-100 dark:bg-white/5">
                    <svg
                        className={`fill-primary stroke-primary duration-200 ease-in-out ${active ? "rotate-180" : ""
                            }`}
                        width="17"
                        height="10"
                        viewBox="0 0 17 10"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7.28687 8.43257L7.28679 8.43265L7.29496 8.43985C7.62576 8.73124 8.02464 8.86001 8.41472 8.86001C8.83092 8.86001 9.22376 8.69083 9.53447 8.41713L9.53454 8.41721L9.54184 8.41052L15.7631 2.70784L15.7691 2.70231L15.7749 2.69659C16.0981 2.38028 16.1985 1.80579 15.7981 1.41393C15.4803 1.1028 14.9167 1.00854 14.5249 1.38489L8.41472 7.00806L2.29995 1.38063L2.29151 1.37286L2.28271 1.36548C1.93092 1.07036 1.38469 1.06804 1.03129 1.41393L1.01755 1.42738L1.00488 1.44184C0.69687 1.79355 0.695778 2.34549 1.0545 2.69659L1.05999 2.70196L1.06565 2.70717L7.28687 8.43257Z"
                            fill=""
                            stroke=""
                        />
                    </svg>
                </div>

                <div className="w-full">
                    <h4 className="mt-1 text-lg font-bold text-mcolor font-mfont dark:text-white">
                        {header}
                    </h4>
                </div>
            </button>

            <div className={`pl-[62px] duration-200 ease-in-out ${active ? "block" : "hidden"}`}  >
                <p className="py-3 text-base leading-relaxed font-mfont font-semibold text-body-color dark:text-dark-6">
                    {text}
                </p>
            </div>
        </div>
    );
};
